import "./FormFieldStyle.scss";
import { DatePicker } from "../../ui/date.picker";
import { NumberInput } from "../../ui/number.input";
import { helper } from "../../core/helper";
import { AutoSuggest } from "../../ui/auto.suggest";
var FormFieldComponent = /** @class */ (function () {
    function FormFieldComponent(options) {
        this.options = options;
        this.id = options.id || helper.newDomGuid();
        this.type = this.options.type === "password" ? "password" : "text";
    }
    FormFieldComponent.prototype.render = function () {
        var _a, _b;
        return {
            tag: "div",
            attr: { class: "form-field " + (this.options.value ? "form-field--is-filled " : "") + ((_a = this.options.class) !== null && _a !== void 0 ? _a : "") },
            children: [{
                    tag: "div",
                    attr: { class: "form-field__control" + (this.validationMessage ? " failed__valid" : "") },
                    children: [
                        {
                            tag: "label",
                            attr: { for: this.id, class: "form-field__label" },
                            content: this.options.label +
                                (this.options.required ? " *" : "") +
                                (this.validationMessage ? (" " + ((_b = this.validationMessage) !== null && _b !== void 0 ? _b : "")) : "")
                        },
                        {
                            tag: "input",
                            attr: {
                                id: this.id,
                                type: this.type,
                                value: this.options.value,
                                maxLength: this.options.maxLength,
                                class: "form-field__input",
                                blur: this.setInActive,
                                focus: this.setActive,
                                input: this.onInput,
                                disabled: this.options.disabled ? "disabled" : undefined
                            }
                        }
                    ]
                }]
        };
    };
    FormFieldComponent.prototype.onCreate = function (node) {
        var InputDom = node.dom.firstElementChild.children[1];
        if (this.options.type === "number") {
            NumberInput(InputDom, this.options.numberOptions);
        }
        else if (this.options.type === "date") {
            this.datepickerRef = DatePicker(InputDom, this.options.dateOptions);
        }
        else if (this.options.type === "autosuggest") {
            AutoSuggest(InputDom, this.options.autoSuggestOptions);
        }
    };
    FormFieldComponent.prototype.onRemove = function (node) {
        if (this.datepickerRef != null) {
            this.datepickerRef.destroy();
        }
    };
    FormFieldComponent.prototype.validate = function () {
        var value = this.getValue();
        if (this.options.required && !value) {
            this.validationMessage = " ";
            return false;
        }
        if (this.options.onValidate) {
            var validationResult = this.options.onValidate(value);
            if (validationResult === false) {
                this.validationMessage = " ";
                return false;
            }
            if (validationResult !== true) {
                this.validationMessage = validationResult;
                return false;
            }
        }
        this.validationMessage = null;
        return true;
    };
    FormFieldComponent.prototype.getValue = function () {
        var _a;
        return (_a = document.getElementById(this.id)) === null || _a === void 0 ? void 0 : _a.value;
    };
    FormFieldComponent.prototype.setValue = function (value) {
        var el = document.getElementById(this.id);
        if (el == null) {
            return;
        }
        el.value = value || "";
        if (value) {
            el.parentElement.classList.add("form-field--is-filled");
        }
        else {
            el.parentElement.classList.remove("form-field--is-filled");
        }
    };
    FormFieldComponent.prototype.setInActive = function (evt, node) {
        var formField = node.dom.parentElement.parentElement;
        if (formField == null) {
            return;
        }
        setTimeout(function () {
            formField.classList.remove("form-field--is-active");
            if (node.dom.value === "") {
                formField.classList.remove("form-field--is-filled");
            }
            else {
                formField.classList.add("form-field--is-filled");
            }
        }, 250);
        if (this.options.onBlur) {
            this.options.onBlur(evt, node);
            return;
        }
        return false;
    };
    FormFieldComponent.prototype.setActive = function (evt, node) {
        var formField = node.dom.parentElement.parentElement;
        if (formField == null) {
            return;
        }
        formField.classList.add("form-field--is-active");
        if (this.options.onFocus) {
            this.options.onFocus(evt, node);
            return;
        }
        return false;
    };
    FormFieldComponent.prototype.onInput = function (evt, node) {
        if (this.options.onInput) {
            this.options.onInput(evt, node);
            return;
        }
    };
    return FormFieldComponent;
}());
export { FormFieldComponent };
